module.exports = __webpack_public_path__ + "img/Kamalaya.77204a9f.png";